/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombstoneGameModuleConfig} from "./TombstoneGameModuleConfig";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {TombstoneIndividualWPController} from "./winpresentation/individual/TombstoneIndividualWPController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {TombstoneSpinController} from "./spin/TombstoneSpinController";

require("../../node_modules/gsap/src/uncompressed/plugins/PixiPlugin");

export class Tombstone extends SlotGame {
    public static isActionSpinsActive:boolean = false;
    public static individualWin:TombstoneIndividualWPController;
    public static spinController:TombstoneSpinController;

    constructor() {
        super(TombstoneGameModuleConfig.instance);
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "M5",
                    "L4",
                    "L1",
                    "L3",
                    "L2"
                ],
                [
                    "M2",
                    "M5",
                    "L2",
                    "L1",
                    "L4"
                ],
                [
                    "L3",
                    "L2",
                    "M1",
                    "L3",
                    "L4"
                ],
                [
                    "M3",
                    "L1",
                    "M4",
                    "L3",
                    "L1"
                ],
                [
                    "M5",
                    "L4",
                    "B2",
                    "L3",
                    "M5"
                ]
            ],
            "evaluatedArea": [
                [
                    "X",
                    "L1",
                    "L3"
                ],
                [
                    "M5",
                    "L2",
                    "L1"
                ],
                [
                    "L2",
                    "M1",
                    "L3"
                ],
                [
                    "L1",
                    "M4",
                    "L3"
                ],
                [
                    "X",
                    "B",
                    "L3"
                ]
            ],
            "betWayWins": [],
            "totalBetWayWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "superFreespinTriggeredThisSpin": false,
            "bonusTriggeredThisSpin": false,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "freespinMultiplierBefore": 1,
            "freespinMultiplierAfter": 1,
            "overlayWilds": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "overlayWildsBeforeSpin": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "doReelNudge": [
                false,
                false,
                false,
                false,
                false
            ],
            "extraSymbolsOnTop": [
                [
                    "L1",
                    "L2",
                    "M4"
                ],
                [
                    "L4",
                    "M1",
                    "M4"
                ],
                [
                    "S",
                    "M3",
                    "M4"
                ],
                [
                    "L3",
                    "L2",
                    "S"
                ],
                [
                    "L3",
                    "L1",
                    "M4"
                ]
            ],
            "numberOfBonusSpinsPlayed": 0,
            "bonusSpinsLeft": 0,
            "bonusPositions": [
                -1,
                -1,
                -1,
                -1,
                1
            ],
            "stickyWilds": [
                false,
                false,
                false,
                false,
                false
            ],
            "multiplierOnReel": [
                0,
                0,
                0,
                0,
                0
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false
            ]
        };
    }

    getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {
            value = value.replace(new RegExp("#isGreece", "g"), (Tombstone.api.gameClientConfiguration.jurisdictionName !== "GR" ? "isGreeceJur" : ""));
            return value;
        });
    }

    getReadyToStart():Promise<NolimitPlugin> {
        SlotGame.api.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data:any)=>{
            if (data === true){
                Tombstone.isActionSpinsActive = true;
                EventHandler.dispatchEvent(new GameEvent(SpinEvent.BEFORE_START));
                Tombstone.individualWin.abort();
                Tombstone.spinController.clear();
            } else {
                EventHandler.dispatchEvent(new GameEvent(SpinEvent.BEFORE_START));
                Tombstone.isActionSpinsActive = false;
                Tombstone.spinController.clear();
            }
        });

        return super.getReadyToStart();
    }
}